<template>
  <v-dialog v-model="model" max-width="400">
    <v-card>
      <v-row align="center" justify="center" class="text-center pa-4">
        <div class="headline text-center mb-2">{{title}}</div>
        {{ message }}
        <div class="mt-4">
          <v-btn color="primary" rounded @click.native="didDismiss">Ok</v-btn>
        </div>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['model', 'didDismiss'],
  computed: {
    title () {
      return this.$store.getters.globalErrorTitle
    },
    message () {
      return this.$store.getters.globalErrorMessage
    }
  },
  methods: {
    submit () {
      this.$props.didDismiss()
    }
  }
}
</script>
